import React, { useState, ReactNode, forwardRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Badge from "@mui/material/Badge";
import { TransitionProps } from "@mui/material/transitions";
import { PiCaretLeft, PiArrowClockwise, PiChat } from "react-icons/pi";

import { RootState } from "../store";
import Chat from "../features/Chat";

// Transition component for Dialog
const Transition = forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface BottomMenuDecoratorProps {
  children: ReactNode;
}

const BottomMenuDecorator: React.FC<BottomMenuDecoratorProps> = ({ children }) => {
  const navigate = useNavigate();
  const authUserId = useSelector((state: RootState) => state.authentication.userId);
  const messageStates = useSelector(
    (state: RootState) =>
      state.entities.messageStates.byUserIdAndViewedAtIsNull[authUserId]
  );

  const [open, setOpen] = useState(false);

  const handleClikGoBack = () => navigate(-1);

  const handleClickReload = () => navigate(0);

  const handleClickOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  return (
    <>
      {children}
      <div className="help">
        <a className="btn btn-lg transition text-white" onClick={handleClikGoBack}>
          <PiCaretLeft />
        </a>
        <a className="btn btn-lg transition text-white border-start" onClick={handleClickReload}>
          <PiArrowClockwise />
        </a>
        <a className="btn btn-lg transition text-white border-start" onClick={handleClickOpen}>
          <Badge badgeContent={messageStates?.length} color="primary">
            <PiChat />
          </Badge>
          <span style={{ fontSize: 13 }}> + AI</span>
        </a>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
          PaperProps={{
            sx: {
              backgroundColor: (theme) => theme.palette.background.default,
              backgroundImage: "none",
            },
          }}
        >
          <Chat handleClose={handleClose} />
        </Dialog>
      </div>
    </>
  );
};

export default BottomMenuDecorator;